// extracted by mini-css-extract-plugin
export default {"total":"ReceivablePaymentModal_total__-9Ceo"};